import React from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box,
} from "@mui/material";
import { Loader, EmptyState } from "./Common";

/**
 * columns: [{ key, label, render?: (row) => node, width? }]
 * rows: array of data objects
 * onRowClick?: (row) => void
 */
export default function DataTable({ columns, rows, loading, emptyMessage = "No records found", onRowClick, footer, getRowSx }) {
  if (loading) return <Loader />;
  if (!rows || rows.length === 0) return <EmptyState title={emptyMessage} />;

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden" }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key} sx={{ width: col.width }}>{col.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow
                key={row.id ?? idx}
                hover={Boolean(onRowClick)}
                onClick={() => onRowClick && onRowClick(row)}
                sx={{ cursor: onRowClick ? "pointer" : "default", ...(getRowSx ? getRowSx(row) : {}) }}
              >
                {columns.map((col) => (
                  <TableCell key={col.key}>{col.render ? col.render(row) : row[col.key]}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {footer && <Box sx={{ p: 1.5, borderTop: "1px solid #eee" }}>{footer}</Box>}
    </Paper>
  );
}
